function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "download-letter");

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 18.31,
    height: 16.07,
    viewBox: "0 0 18.31 16.07"
  }, props), _ref, React.createElement("g", null, React.createElement("polygon", {
    points: "2.18 8.9 2.18 13.35 2.18 13.64 16.13 13.64 16.13 13.35 16.13 8.9 16.13 7.69 18.31 7.69 18.31 16.07 0 16.07 0 7.69 2.18 7.69 2.18 8.9",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("polygon", {
    points: "6.88 0 6.88 5.15 3.26 5.15 9.04 11.86 15.04 5.15 11.51 5.15 11.51 0 6.88 0",
    style: {
      "fill": "#fff"
    }
  })));
};

export default __webpack_public_path__ + "static/media/download-letter.fca0b7f1.svg";
export { SvgComponent as ReactComponent };